import { createRouter, createWebHistory } from "vue-router";
import home from "./home";
import admin from "./admin";

const routes = [...home, ...admin];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "Store Thanh Danh";

  const token = localStorage.getItem("admin_token");

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
           next({ name: 'LoginAdmin' });

    } else {
      next();
    }
  } else {
    if (to.name === 'LoginAdmin' && token) {
      next({ name: 'AdminDashboard' });
    } else {
      next();
    }
  }
});
export default router;
